<div class="form-group" *ngIf="isVisible">
	<label class="form-control-label" for="salaryRange">Faixa Salarial</label>
	<ng-select container="body" class="cost-centers-options auto-grow-options" labelForId="salaryRange"
		[items]="options" [formControl]="$any(control)" [compareWith]="compareRanges" [loading]="state === 'loading'"
		[clearable]="false" [searchable]="false" placeholder="Faixa Salarial" loadingText="Carregando faixas..."
		(change)="onChange($event)">
		<ng-template ng-label-tmp let-item="item">{{ formatLabel(item) }}</ng-template>
		<ng-template ng-option-tmp let-item="item">{{ formatLabel(item) }}</ng-template>
	</ng-select>
	<small class="text-muted" *ngIf="state === 'loading'">Carregando faixas da grade salarial...</small>
	<small class="text-danger d-block" *ngIf="state === 'failed'">
		Não foi possível carregar as faixas da grade salarial.
		<a href="javascript:void(0)" (click)="retry()">Tentar novamente</a>
	</small>
	<small class="text-danger d-block" *ngIf="showRequiredError">Faixa Salarial é obrigatória.</small>
</div>
